/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Time({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/SchedulingPreferences/Content/Time"
  
}) {
let schedulingPreferencesStartHourValueData = fromData.useDataValue({ viewPath,
context: 'scheduling_preferences',
path: 'start_hour',
})
let hoursValueData = fromData.useDataValue({ viewPath,
context: 'hours',
})
let aggregateData = fromHelpers.show_hours(schedulingPreferencesStartHourValueData, hoursValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let schedulingPreferencesEndHourValueData = fromData.useDataValue({ viewPath,
context: 'scheduling_preferences',
path: 'end_hour',
})
let hoursValueData1 = fromData.useDataValue({ viewPath,
context: 'hours',
})
let aggregateData1 = fromHelpers.show_hours(schedulingPreferencesEndHourValueData, hoursValueData1)
  return (<React.Fragment
>
<div
  data-testid="Time.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="From"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 data="scheduling_preferences.start_hour"
 data="hours"
 aggregate="helpers.js show_hours"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 text="to"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 data="scheduling_preferences.end_hour"
 data="hours"
 aggregate="helpers.js show_hours"
 text={aggregateData1}
/>
</div>
{children}
</React.Fragment>)
}